import { AfterViewInit, Component, ElementRef, OnInit, QueryList, ViewChildren, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { BreadcrumbComponent } from '../../Common/Components/breadcrumb/breadcrumb.component';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { RouterModule, ActivatedRoute } from '@angular/router';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { CommonModule } from '@angular/common';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { SpinnerComponent } from '../../Common/Components/spinner/spinner.component';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzInputModule } from 'ng-zorro-antd/input';
import { ApiService } from '../../Services/api.service';
import { AuthService } from '../../Services/auth.service';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FormArray, FormControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { CatalogAttributeAddEditComponent } from './catalog-attribute-add-edit/catalog-attribute-add-edit.component';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { debounceTime, distinctUntilChanged, startWith } from 'rxjs';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { AddProductDetailsComponent } from "../catalog-manage/add-product-details/add-product-details.component";
import { ConfirmPopupComponent } from '../../Common/Components/confirm-popup/confirm-popup.component';
import { AssociatedProductsComponent } from './associated-products/associated-products.component';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { UppercaseDirective } from '../../Common/Components/pipe/UpperCasePipe/uppercase.pipe';
import { NzSwitchModule } from 'ng-zorro-antd/switch';

@Component({
  selector: 'app-master-catalog',
  standalone: true,
  imports: [NzButtonModule, FormsModule, NzDrawerModule, NzToolTipModule,
    NzAutocompleteModule, NzInputModule, CatalogAttributeAddEditComponent,
    ReactiveFormsModule, DragDropModule, AssociatedProductsComponent, NzSwitchModule,
    RouterModule, NzInputModule, NzRadioModule, NzCollapseModule, NzDropDownModule, NzBadgeModule,
    SpinnerComponent, NzIconModule, NzTagModule, CommonModule, NzSelectModule, ConfirmPopupComponent,
    NzCollapseModule, AddProductDetailsComponent],
  templateUrl: './master-catalog.component.html',
  styleUrl: './master-catalog.component.scss'
})


export class MasterCatalogComponent implements OnInit, AfterViewInit {
  @Input() selectedProdctId: any;
  @Input() selectedVersion: any;
  @Input() showAsDrawer: any = false;
  isAllExpanded: boolean = false;
  @Input() openUpdateWindow: any = false;
  @Output() dataSavedSuccessfully = new EventEmitter<boolean>();
  @ViewChildren('panelRef', { read: ElementRef }) panelElements!: QueryList<ElementRef>;
  @ViewChild(AssociatedProductsComponent) public associatedProductsComponent!: AssociatedProductsComponent;

  breadcrumbs: Array<{ label: string, url: any }> = [
    {
      label: "Master Catalog",
      url: ""
    }
  ];
  masterCatalogFields = [
    { type: "input", label: "Style ID", placeholder: "Enter Style ID", value: "", formControlName: "styleId", autocomplete: true },
    { type: "input", label: "Version", placeholder: "Enter Version", value: "", formControlName: "newVersion", maxLength: 25 },
    { type: "input", label: "Display Name", placeholder: "Enter Display Name", value: "", formControlName: "displayName", maxLength: 100 },
    { type: "textarea", label: "Description", placeholder: "Enter Description", value: "", rows: 1, formControlName: "desc", maxLength: 100 },
    { type: "input", label: "Brand", placeholder: "Enter Brand", value: "", formControlName: "brand", autocomplete: true },
    { type: "input", label: "Garment", placeholder: "Enter Garment", value: "Shirts", formControlName: "garment", autocomplete: true },
    { type: "input", label: "Sub-garment", placeholder: "Enter Sub-garment", value: "", formControlName: "subGarment", autocomplete: true },
    { type: "input", label: "Garment Clarifier", placeholder: "Enter Garment Clarifier", value: "", formControlName: "garmentClarifier" },
    { type: "dropdown", label: "Gender", placeholder: "", value: "", formControlName: "gender" },
    { type: "dropdown", label: "CAT Level", placeholder: "", value: "", formControlName: "catLevel" },
    { type: "checkbox", label: "UL Classified", placeholder: "", value: "", formControlName: "ulClassified" }
  ];
  selectedBrand: string = '';
  selectedGarment: string = '';
  radioValue: string = '';
  selectedSubGarment: string = '';
  catalogAddForm: boolean = false;
  attributeList: any = [
    {
      id: 1, fieldType: "accordion", collapse: true, groupHeader: "Group", required: true,
      fields: [
        { fieldName: "Attribute Name", fieldType: "input", placeholder: "Enter", value: "Benefits" },
        { fieldName: "Attribute Values", fieldType: "input", placeholder: "Enter", value: "Wrinkle-resistant" },
        { fieldName: "Value", fieldType: "button", placeholder: "Value", icon: 'plus' }]
    }
  ];
  viewEditForm: string = '';
  isLoading: boolean = false;
  masterCatalogData: any;
  addEditCatalogForm: FormGroup = new FormGroup({});
  attributeArrayForm: FormGroup = new FormGroup({});
  attrValArrayForm: FormGroup = new FormGroup({});
  actionValue: string = "";
  inValidAttrValForm: boolean = false;
  inValidProductForm: boolean = false;
  styleIdList: any = [];
  filteredStyleIdList: any = [];
  filteredBrandList: any = [];
  filteredGarmentList: any = [];
  filteredSubGarmentList: any = [];
  brandList: any = [];
  garmentList: any = [];
  subGarmentList: any = [];
  cloneBrandList: any = [];
  cloneGarmentList: any = [];
  cloneSubGarmentList: any = [];
  attirbutePanel: boolean = false;
  inValidProductSearch: boolean = false;
  selectedCatalogId: string = "";
  selectedProdctDetails: any;
  salsifyProduct: boolean = false;
  deletedProduct: boolean = false;
  copyProduct: boolean = false;
  bulletList: any = ['0'];
  activeContainer: boolean = true;
  activeTag: boolean = true;
  masterCatalogAttirbutes: any;
  isEditPage: boolean = false;
  attributeFormatSwitchValue: boolean = true;
  isProductLoading: boolean = false;
  showModal: boolean = false;
  invalidProdctDetails: boolean = false;
  productList: boolean = false;
  resetListDetails: any;
  saveMc:boolean = false;
  displayLimit = 10;



  constructor(public apiService: ApiService, private fb: FormBuilder,
    public authService: AuthService, private route: ActivatedRoute) { }

  getTitle() {
    return this.viewEditForm == "Add" ? "Add Product" : this.viewEditForm == "View" ? 'View  Product' : this.viewEditForm == "Edit" ? 'Edit Product' : '';
  }

  handleCollapse(i: number) {
    let attrList = this.attrArray.value;
    attrList[i].collapse = !attrList[i].collapse;
    this.attrArray.patchValue(attrList);
  }

  ngOnInit(): void {
    this.initAddForm();
    this.resetListDetails = {};
    this.saveMc = false;
    if (this.selectedProdctId && this.selectedProdctId != '' && this.selectedProdctId != undefined) {
      this.getProductAPI();
    }

  }


  getMasterCatalogAttributes(): void {
    this.apiService.getMasterCatalogAttributes().subscribe(res => {
      this.masterCatalogAttirbutes = res;
    })
  }

  getStyleList() {
    this.apiService.getStyleList().subscribe(response => {
      this.styleIdList = response;
      this.filteredStyleIdList = response;
    })
  }

  getBrandList() {
    // this.isLoading = true;
    this.apiService.getBrandList().subscribe(response => {
      // this.isLoading = false;
      this.brandList = response;
      this.cloneBrandList = response;
      this.filteredBrandList = response;
    })
  }

  getGarmentList(brand: string, formFilter?: boolean) {
    this.apiService.getGarmentList(brand).subscribe(response => {
      if (formFilter) {
        this.cloneGarmentList = response;
      }
      else {
        this.garmentList = response;
        this.filteredGarmentList = response;
      }
    })
  }

  getSubGarmentList(brand: string, garment: string, formFilter?: boolean) {
    this.apiService.getSubGarmentList(brand, garment).subscribe(response => {
      if (formFilter) {
        this.cloneSubGarmentList = response;
      }
      else {
        this.subGarmentList = response;
        this.filteredSubGarmentList = response;
      }
    })
  }
  ngAfterViewInit(): void {
    this.panelElements.changes.subscribe(node => {
      if (this.actionValue)
        this.focusPanel();
    })
  }

  initAddForm() {
    this.addEditCatalogForm = this.fb.group({
      styleId: ['', Validators.required],
      version: [''],
      newVersion: [''],
      displayName: ['', Validators.required],
      desc: [''],
      brand: ['', Validators.required],
      garment: ['', Validators.required],
      subGarment: ['', Validators.required],
      garmentClarifier: [''],
      gender: ['', Validators.required],
      ulClassified: [false],
      catLevel: [''],
      attributeArray: this.fb.array([], Validators.minLength(1)),
      keyWord: [''],
      keyWords: this.fb.array([])
    });

    this.addEditCatalogForm.get('newVersion')?.disable()
    const styleIdControl = this.addEditCatalogForm.get('styleId');
    const brandControl = this.addEditCatalogForm.get('brand');
    const garmentControl = this.addEditCatalogForm.get('garment');
    const subGarmentControl = this.addEditCatalogForm.get('subGarment');

    if (styleIdControl) {
      styleIdControl.valueChanges.pipe(
        startWith(''),
        debounceTime(300),
        distinctUntilChanged()
      ).subscribe(value => {
        this.filterStyleData(value);
      });
    }
    if (brandControl) {
      brandControl.valueChanges.pipe(
        debounceTime(300),
        distinctUntilChanged()
      ).subscribe(value => {
        this.filterBrandData(value);
      });
    }
    if (garmentControl) {
      garmentControl.valueChanges.pipe(
        debounceTime(300),
        distinctUntilChanged()
      ).subscribe(value => {
        this.filterGarmentData(value);
      });
    }
    if (subGarmentControl) {
      subGarmentControl.valueChanges.pipe(
        startWith(''),
        debounceTime(300),
        distinctUntilChanged()
      ).subscribe(value => {
        this.filterSubGarmentData(value);
      });
    }
  }

  validateSelection(formparam: string): void {
    if (formparam && formparam == 'styleId') {
      const isValid = this.styleIdList.some(
        (option: any) => option?.styleId === this.addEditCatalogForm.get(formparam)?.value
      );

      if (!isValid) {
        this.addEditCatalogForm.get(formparam)?.setValue('');
      }
    }
    else {
      return
    }
  }

  filterStyleData(value: string): void {
    const filterValue = (value || '').toLowerCase();
    this.filteredStyleIdList = this.styleIdList.filter((option: any) =>
      option.styleId.toLowerCase().includes(filterValue)
    );
  }
  filterBrandData(value: string): void {
    const filterValue = (value || '').toLowerCase();

    this.filteredBrandList = this.cloneBrandList.filter((option: any) =>
      option.toLowerCase().includes(filterValue)
    );
    this.getGarmentList(value, true);
  }
  filterGarmentData(value: string): void {
    const filterValue = (value || '').toLowerCase();

    this.filteredGarmentList = this.cloneGarmentList.filter((option: any) =>
      option.toLowerCase().includes(filterValue)
    );
    this.getSubGarmentList(this.addEditCatalogForm.controls["brand"].value, value, true);
  }
  filterSubGarmentData(value: string): void {
    const filterValue = (value || '').toLowerCase();

    this.filteredSubGarmentList = this.cloneSubGarmentList.filter((option: any) =>
      option.toLowerCase().includes(filterValue)
    );
  }

  get attrArray() {
    return this.addEditCatalogForm.controls["attributeArray"] as FormArray;
  }

  focusPanel() {
    this.panelElements.last.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    this.actionValue = '';
  }

  get attrArrayControls() {
    return (this.addEditCatalogForm.controls["attributeArray"] as FormArray).controls as FormGroup[];
  }

  isAccessExists(): boolean {
    return this.viewEditForm == 'Add' ? (this.authService.MCAdd ? true : false) : (this.authService.MCAdd ? true : false);
  }

  loadMasterCatalogProduct(product: any) {
    this.selectedProdctId = product.data["styleId"];
    this.selectedVersion = product.data["version"];
    // this.setFormAccess(product.data, product.action);

    // this.viewEditForm = product.data['salsify'] == 1 ? 'View' : 'Edit';
    // this.viewEditForm = product.action == 'Copy' ? 'Add' : this.viewEditForm;
    // this.salsifyProduct = product.data['salsify'] == 1 ? true : false;
    this.deletedProduct = product.data['deleteInd'] == 1 ? true : false;
    // this.copyProduct =  product.action == 'Copy' ? true : false;
    this.getProductAPI(product.action);
  }

  setFormAccess(data: any, action: any) {
    this.viewEditForm = data['salsify'] == 1 ? 'View' : 'Edit';
    this.viewEditForm = action == 'Copy' ? 'Add' : this.viewEditForm;
    this.salsifyProduct = data['salsify'] == 1 ? true : false;
    // this.deletedProduct = data['deleteInd'] == 1 ? true : false;
    this.copyProduct = action == 'Copy' ? true : false;
  }

  getProductAPI(action?: string) {
    this.isProductLoading = true;
    this.apiService.getProductDetails(this.selectedProdctId, this.selectedVersion).subscribe(res => {
      this.isProductLoading = false;
      this.isEditPage = action == 'Copy' ? false : true;
      this.selectedProdctDetails = res;
      this.setFormAccess(this.selectedProdctDetails.productInfo, action);
      this.attributeFormatSwitchValue = this.selectedProdctDetails.productInfo.attributeFormat ? true : false;
      this.loadCatalogForm(action);
      this.loadFormDropdownData();
    })
  }

  loadFormDropdownData(): void {
    this.getStyleList();
    this.getBrandList();
    this.getMasterCatalogAttributes();
  }

  loadCatalogForm(action?: string) {
    this.addEditCatalogForm.patchValue({
      styleId: this.selectedProdctDetails.productInfo.styleId,
      version: this.selectedProdctDetails.productInfo.version,
      newVersion: this.selectedProdctDetails.productInfo.version,
      displayName: this.decodeHtml(this.selectedProdctDetails.productInfo.displayName),
      desc: this.decodeHtml(this.selectedProdctDetails.productInfo.description),
      brand: this.selectedProdctDetails.productInfo.brand,
      garment: this.selectedProdctDetails.productInfo.garment,
      subGarment: this.selectedProdctDetails.productInfo.subGarment,
      garmentClarifier: this.selectedProdctDetails.productInfo.garmentClarifier,
      gender: this.selectedProdctDetails.productInfo.gender.toString(),
      ulClassified: this.selectedProdctDetails.productInfo.ulClassified == 0 ? false : true,
      catLevel: this.selectedProdctDetails.productInfo.catLevel.toString(),
    });
    this.patchItemtoAttributeArray();
    this.patchItemtoKeyWordsArray();
    if ((this.salsifyProduct && !this.copyProduct) || this.deletedProduct || !this.authService.MCAdd) {
      this.addEditCatalogForm.disable();
      this.masterCatalogFields[1].maxLength = undefined;
      this.masterCatalogFields[2].maxLength = undefined;
    }
    else {
      this.addEditCatalogForm.enable();
      this.addEditCatalogForm.get('styleId')?.disable();
      if (this.selectedVersion || action == 'Copy') {
        this.addEditCatalogForm.get('newVersion')?.enable();
        this.addEditCatalogForm.get('newVersion')?.setValidators([Validators.required]);
      }
      else {
        this.addEditCatalogForm.get('newVersion')?.disable();
        this.addEditCatalogForm.get('newVersion')?.clearValidators();
      }
      this.masterCatalogFields[1].maxLength = 25;
      this.masterCatalogFields[2].maxLength = 100;
    }
    if (this.openUpdateWindow) {
      this.attirbutePanel = true;
    }
  }

  loadAddForm() {
    this.inValidProductForm = false;
    if (this.viewEditForm == 'View' || this.viewEditForm == 'Edit') {
      this.addEditCatalogForm.reset();
      this.addEditCatalogForm.enable();
    }
    this.viewEditForm = 'Add';
    this.addEditCatalogForm.get('newVersion')?.disable();
    this.addEditCatalogForm.get('newVersion')?.clearValidators();
    this.catalogAddForm = true;
    this.salsifyProduct = false;
    this.copyProduct = false;
    this.deletedProduct = false;
    this.isEditPage = false;
    this.keyWordsArray.clear();
    this.attrArray.clear();
    this.loadFormDropdownData();
  }

  reset() {
    this.viewEditForm = '';
    this.addEditCatalogForm.reset();
    this.addEditCatalogForm.enable()
  }

  patchItemtoAttributeArray() {
    this.attrArray.clear();
    this.selectedProdctDetails.attributes.map((node: any) => {
      this.attributeArrayForm = this.fb.group({
        attributeName: [node.displayName],
        attributeValue: [''],
        attributeId: [node.attributeId],
        collapse: [true],
        attrValArray: this.fb.array([])
      });
      this.attrArray.push(this.attributeArrayForm);
      if (node.attributeValues.length > 0) {
        node.attributeValues.map((node1: any) => {
          const attrValArr = this.attributeArrayForm.get('attrValArray') as FormArray;
          this.attrValArrayForm = this.fb.group({
            attributeValue: [node1.attributeValue]
          });
          attrValArr.push(this.attrValArrayForm);
        })
      }
    })
  }

  patchItemtoKeyWordsArray() {
    this.keyWordsArray.clear();
    this.selectedProdctDetails.keywords.map((node: any) => {
      this.keyWordsArray.push(new FormControl(node));
    })
  }


  addIsOpenProperty(node: any, isOpenValue: boolean) {
    node.isOpen = isOpenValue;
    node.hovered = false;
    node.isMenuOpen = false;
    node.isPreviewOpen = false;
    if (node.garments && Array.isArray(node.garments)) {
      node.garments.forEach((childNode: any) => this.addIsOpenProperty(childNode, isOpenValue));
      if (node.subgarments && Array.isArray(node.subgarments)) {
        node.subgarments.forEach((childNode: any) => this.addIsOpenProperty(childNode, isOpenValue));
      }
    }

  }

  addIsMenuOpenProperty(node: any, isOpenValue: boolean) {
    if (!Array.isArray(node)) {
      node.isMenuOpen = isOpenValue;
      node.hovered = isOpenValue;
    }

    if (node && Array.isArray(node)) {
      node.forEach((childNode: any) => this.addIsMenuOpenProperty(childNode, isOpenValue));
    }

  }

  handleHover(catalog: any, parentList: any, state: boolean) {
    if (state == true) {
      catalog['hovered'] = true;

    }
    else {
      if (catalog['isMenuOpen']) {
        catalog['hovered'] = true
      }
      else {
        catalog['hovered'] = false
      }

    }
  }

  selectedOption(evt: any, label: string) { }

  onPanelClose(state: boolean, childNode: any, parentList: any, index: number): void {
    this.addIsOpenProperty(parentList[index], false);
    childNode.isOpen = state;
    childNode.hovered = false;
    childNode.isMenuOpen = false;
  }

  getCtrlValue(name?: string) {
    if (!name) {
      return null;
    }
    return this.addEditCatalogForm.get(name);
  }

  addAttrData(event: any) {
    this.attrArray.clear();
    this.attirbutePanel = false;
    this.attributeFormatSwitchValue = event.attributeFormatSwitchValue;
    event.filteredAttrArray.map((node: any) => {
      this.attributeArrayForm = this.fb.group({
        attributeName: [node.attributeName],
        attributeValue: [''],
        attributeId: [node.attributeId],
        collapse: [true],
        attrValArray: this.fb.array([])
      });
      this.attrArray.push(this.attributeArrayForm);
      if (node.attrValArray.length > 0) {
        node.attrValArray.map((node1: any) => {
          const attrValArr = this.attributeArrayForm.get('attrValArray') as FormArray;
          this.attrValArrayForm = this.fb.group({
            attributeValue: [node1.attributeValue]
          });
          if (node1.attributeValue !== '') {
            attrValArr.push(this.attrValArrayForm);
          }
        })
      }
    })
    setTimeout(() => {
      this.focusPanel();
    }, 500);

    if (event.autoUpdate) {
      this.addProduct(this.addEditCatalogForm);
    }

  }

  get keyWordsArray(): FormArray {
    return this.addEditCatalogForm.get('keyWords') as FormArray;
  }

  get attrValArray() {
    return this.attributeArrayForm.get('attrValArray') as FormArray;
  }

  enterKeyword(ev: any) {
  }
  addKeyWord() {
    if (!this.addEditCatalogForm.controls['keyWord'].value) {
      return;
    }
    this.keyWordsArray.push(new FormControl(this.addEditCatalogForm.controls['keyWord'].value));
    this.addEditCatalogForm.controls['keyWord'].setValue('');
  }

  removeKeyWord(index: number): void {
    if (index >= 0 && index < this.keyWordsArray.length) {
      this.keyWordsArray.removeAt(index);
    }
  }

  drop(event: CdkDragDrop<any[]>, parentCategory: any) {
    moveItemInArray(parentCategory, event.previousIndex, event.currentIndex);
    const keyWords = this.addEditCatalogForm.get('Keywords') as FormGroup;
    // keyWords.patchValue(parentCategory);
    this.keyWordsArray.updateValueAndValidity();
  }

  addProduct(form: FormGroup) {
    if (!form.valid) {
      this.inValidProductForm = true;
      return;
    }
    let attrArray: any = [];
    const allEven = this.addEditCatalogForm.controls.attributeArray.value.every(function (node: any) {
      return node.attrValArray.length > 0;
    });
    if (!allEven) {
      this.apiService.createNotification('error', 'Attribute Values is Mandatory');
    }
    this.isProductLoading = true;
    this.resetListDetails = {};
    this.saveMc = false;
    this.addEditCatalogForm.controls.attributeArray.value.forEach((control: any, index: any) => {
      attrArray.push({
        "attributeId": control.attributeId,
        "attributeValues": control.attrValArray
      })
    });
    let productInfo: any = {
      "styleId": this.addEditCatalogForm.controls['styleId'].value,
      "version": this.addEditCatalogForm.controls['version'].value ? this.addEditCatalogForm.controls['version'].value : '',
      "newVersion": this.addEditCatalogForm.controls['newVersion'].value ? this.addEditCatalogForm.controls['newVersion'].value : '',
      "displayName": this.addEditCatalogForm.controls['displayName'].value,
      "description": this.addEditCatalogForm.controls['desc'].value,
      "ulClassified": this.addEditCatalogForm.controls['ulClassified'].value ? 1 : 0,
      "brand": this.addEditCatalogForm.controls['brand'].value,
      "garment": this.addEditCatalogForm.controls['garment'].value,
      "garmentClarifier": this.addEditCatalogForm.controls['garmentClarifier'].value,
      "subGarment": this.addEditCatalogForm.controls['subGarment'].value,
      "catLevel": this.addEditCatalogForm.controls['catLevel'].value == "" ? 0 : Number(this.addEditCatalogForm.controls['catLevel'].value),
      "gender": Number(this.addEditCatalogForm.controls['gender'].value)
    };

    let data = {
      "productInfo": productInfo,
      "attributes": attrArray,
      "keywords": this.keyWordsArray.value
    }
    let postUrl = this.viewEditForm == 'Add' ? this.apiService.addMasterCatalogProduct(data) : this.apiService.editMasterCatalogProduct(data);
    postUrl.subscribe((res: any) => {
      if (res.statusCode == 200 || res.statusCode == 201) {
        this.isProductLoading = false;
        this.selectedProdctId = this.addEditCatalogForm.controls['styleId'].value;
        this.selectedVersion = this.addEditCatalogForm.controls['newVersion'].value ? this.addEditCatalogForm.controls['newVersion'].value : '';
        this.resetListDetails = { selectedProdctId: this.selectedProdctId, selectedVersion: this.selectedVersion, resetList: true }
        this.getProductAPI();
        if(this.viewEditForm == 'Add'){
          this.saveMc = true;
        }
        this.viewEditForm = 'Edit';
        this.apiService.createNotification('success', res.message);
        if (this.showAsDrawer) {
          this.dataSavedSuccessfully.emit(true);
        }
      }
    }, (error: any) => {
      this.isProductLoading = false;
      this.apiService.createNotification('error', error.error.message);
    });
  }

  resetForm() {
    this.showModal = false;
    this.addEditCatalogForm.reset();

    if (this.selectedProdctDetails && this.viewEditForm == 'Edit') {
      this.loadCatalogForm();
      this.catalogAddForm = false;
    }
    else {
      this.addEditCatalogForm.enable();
      this.addEditCatalogForm.get('newVersion')?.disable()
      this.keyWordsArray.clear();
      this.attrArray.clear();
      this.selectedProdctDetails = {};
      this.catalogAddForm = true;
    }
  }

  decodeHtml(value: string) {
    const txt = document.createElement("textarea");
    txt.innerHTML = value;
    return txt.value;
  }

  toggleLots() {
    if (this.displayLimit === 10) {
      this.displayLimit = this.selectedProdctDetails.lots.length;
    } else {
      this.displayLimit = 10;
    }
  }

  convertToUppercase(controlName: string): void {
    const control = this.addEditCatalogForm.get(controlName);
    if (control && control.value && controlName == 'styleId') {
      const upperValue = control.value.toUpperCase();

      control.setValue(upperValue, { emitEvent: false });
    }
  }

   updateToggle(evt: any) {
    this.isAllExpanded = evt;

  }

validateVersionInput(event: any, type: 'keydown' | 'paste') {
  const input = event.target as HTMLInputElement;
  const currentVal = input.value;
  const selectionStart = input.selectionStart ?? 0;
  const selectionEnd = input.selectionEnd ?? 0;
  
  let insertedText = '';

  if (type === 'keydown') {
    if (event.key.length > 1 || event.ctrlKey || event.metaKey) {
      return;
    }
    insertedText = event.key;
  } else if (type === 'paste') {
    insertedText = event.clipboardData?.getData('text') || '';
  }

  const predictedVal = 
    currentVal.slice(0, selectionStart) + 
    insertedText + 
    currentVal.slice(selectionEnd);

  // STRICT REGEX: Only alphanumeric, space, '-', and '_' are allowed.
  // The hyphen is placed at the very end (\-_) to prevent accidental ASCII ranges.
  const allowedRegex = /^[a-zA-Z0-9]+([ ]+[a-zA-Z0-9]+|[\-_][a-zA-Z0-9]+)*[ \-_]?$/;

  if (!allowedRegex.test(predictedVal)) {
    event.preventDefault();
  }
}


trimVersion() {
  const control = this.addEditCatalogForm.get('newVersion');
  if (control && control.value) {
    const trimmedValue = control.value.trim();
    
    // Update the form control value and rerun validation rules
    control.setValue(trimmedValue);
    control.updateValueAndValidity();
  }
}




}



